import React from 'react';
import { DataTable } from './users/data-table';
import { userColumns } from './users/columns';

/**
 * Enhanced User Table component using shadcn/ui and TanStack Table
 * @param {Object} props - Component props
 * @param {Array} props.users - Array of user data
 * @param {Function} props.onUserClick - Callback function when user row is clicked
 * @returns {JSX.Element} ShadcnUserTable component
 */
const ShadcnUserTable = ({ users, onUserClick }) => {
  return (
    <DataTable
      columns={userColumns}
      data={users}
      onUserClick={onUserClick}
    />
  );
};

export default ShadcnUserTable;
